/*
 *
 * Diagnostics
 *
 */

import SendDiagnostics from './SendDiagnostics';

export default SendDiagnostics;
